var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phhonor"},[_c('hpheader'),_c('div',{staticClass:"phvir-hea"},[_vm._v(_vm._s(_vm.info.honor))]),_c('div',{staticClass:"phonor-sc"},[_c('el-carousel',_vm._l((_vm.comhonor),function(item){return _c('el-carousel-item',{key:item},[_c('img',{attrs:{"src":item.images}})])}),1)],1),_c('hpfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }